export default __webpack_public_path__ + "static/admission-banner-blue-84b7ce3de53ce2f47687486d2a1c6c05.jpg";